// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__u3uac","Button--Delete":"Button_Button--Delete__osPml","Button--Disabled":"Button_Button--Disabled__7oHHS"};